import { render, staticRenderFns } from "./articalTow.vue?vue&type=template&id=36e93168"
import script from "./articalTow.vue?vue&type=script&lang=js"
export * from "./articalTow.vue?vue&type=script&lang=js"
import style0 from "./articalTow.vue?vue&type=style&index=0&id=36e93168&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports